module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "المناصب-لا-تصنع-النجاح"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المناصبُ لا تصنعُ النّجاحَ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في أثناءِ إحدى المحاضراتِ (لجون ماكسويل) الرّائدِ التّنظيريّ للقيادةِ، تبادرَت إلى مَسامعي عبارةُ \"المكاتبُ لا تصنعُ القادةَ\". أعدتُ الاستماعَ إلى العبارةِ لمرّاتٍ عدّةٍ، وأدركتُ أنّ المناصبَ لا تصنعُ النّاجحينَ بل إنَّ النّاجحين هم مَن يخلقُوا للمناصبِ نجاحاً، ويعطوا للألقابِ قيمةً. فالرّتبُ لا تصنعُ العباقرةَ، والمالُ لا يصنعُ الأغنياءَ، والأسماءُ لا تصنعُ الشهرةَ، والفقرُ لا يخلقُ الفقراءَ، والفشلُ لا يصنعُ الفاشلين، فالنّاجحُ هو من يَصنعُ النّجاحَ في منصبهِ، وليسَ المنصبُ من يخلقُ النّجاحَ للنّاجحين. كم عددُ الوزراءِ في دولتكَ؟ كم عددُ الوزراءِ الّذين حقّقُوا نجاحاً كبيراً في مناصبهم؟ منصبُكَ الحالي لا يعبّرُ عن فشلكَ أو نجاحكَ، ولكنَّ العملَ الّذي تنجزُهُ في ذلكَ المنصبِ هو ما سيعبِّرُ عن نجاحكَ ، أو فشلكَ في منصبكَ. كانَ النّبيُّ محمّدٌ (صلّى اللهُ عليه وسلّم) راعياً للأغنامِ، واليومَ يصنَّفُ كأعظمِ شخصيةٍ مرّت في التّاريخِ البشريِّ. لم يمتلك محمّدٌ (صلى الله عليه وسلم) منصباً رفيعاً عندَ قومهِ، ولكنَّ الأعمالَ العظيمةَ الّتي قامَ بها جعلَت العالمَ يخلِّدُ اسمَه بأحرفٍ من ذهبٍ. لا تخبرِ النّاسَ عن منصبكَ، ولكِن دَع عملَكَ يتحدّثُ عن منصبكَ. تذكّر أنَّ الأحلامَ تُصنَعُ عندَما يشعرُ الإنسانُ بقدرتهِ على التّغييرِ في منصبهِ، وليسَ عندَما يعتلي المناصبَ. فكراسي المناصبِ قد تكونُ متاحةً للجميعِ، ولكنَّ النّجاحَ الّذي قد يتحقّقُ في ذلكَ المنصبِ هو ما قد يصنعُ للمنصبِ قيمةً.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "padding-top": "30px"
    }
  }, [_c('strong', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تستطيع..")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f48c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch009.vue
// module id = 84
// module chunks = 0